<div class="container">
    <div class="var-desc">{{ var_desc | translate}}</div>
</div>
